/* eslint valid-typeof: "off" */

import { types } from '../constants';

/**
 * Assembles a querystring from an object.
 * @param qsMap {object} - A key-value representation of querystring variables
 * @param validationMap {object} - An object whose keys are valid qs vars,
 * and whose values are objects containing `type` and `default` keys
 * @returns {String} - The validated querystring
 */
function buildQuerystring(qsMap = {}, validationMap) {
  if (typeof qsMap !== types.OBJECT) return '';

  const qsVars = Object.keys(qsMap)
    .filter(key => (
      !validationMap || (
        validationMap[key]
        && typeof qsMap[key] === validationMap[key].type
        && qsMap[key] !== validationMap[key].default
      )
    ))
    .map(key => `${key}=${encodeURIComponent(qsMap[key])}`);

  return (qsVars.length > 0) ? `?${qsVars.join('&')}` : '';
}

export default buildQuerystring;
